import 'core-js/es/map';
import 'core-js/es/set';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/main.scss';

import React from 'react';
import ReactDOM from 'react-dom';

// import * as serviceWorker from './serviceWorker';

// Router
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Amplify settings
import { Amplify } from 'aws-amplify';
import config from './config';

// ag-Grid license
import { LicenseManager } from 'ag-grid-enterprise';

// redux
import { Provider as ReduxProvider } from 'react-redux';
import store from './redux/store';

// i18n
import { I18nextProvider } from 'react-i18next';
import i18n from './locales/i18n';

switch (process.env.REACT_APP_ENV) {
  case 'local':
    document.title = 'Timss | local';
    break;
  case 'development':
    document.title = 'Timss | dev';
    break;
  case 'staging':
    document.title = 'Timss | staging';
    break;
  default:
    document.title = 'Timss';
}

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
);

Amplify.configure({
  Auth: {
    Cognito: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
    },
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
  },
  API: {
    REST: {
      millSheetAPIGateway: {
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
        custom_header: config.apiGateway.custom_header,
      },
    },
  },
});

async function main() {
  if (process.env.NODE_ENV === 'development') {
    const { worker } = require('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
    worker.printHandlers();
  }

  ReactDOM.render(
    <ReduxProvider store={store}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </ReduxProvider>,
    document.getElementById('root'),
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();

main();
